import { Injectable, inject } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { getMainLanguage } from '@app/shared/utils/browser-checks';
import * as locales from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';

@Injectable({
  providedIn: 'root',
})
export class BootstrapLocaleService {
  private localeService = inject(BsLocaleService);


  public init(): void {
    //https://placewisegroup.atlassian.net/browse/MPC-6086
    let browserLocale = getMainLanguage().toLowerCase();

    if (['no', 'nn'].includes(browserLocale)) {
      browserLocale = 'nb';
    } else if (browserLocale.includes('en-') && browserLocale !== 'en-gb') {
      browserLocale = 'en';
    }

    for (const locale in locales) {
      defineLocale(locales[locale].abbr, locales[locale]);
    }

    this.localeService.use(browserLocale);
  }
}
